import React, { Component } from 'react';
import logo from './../../assets/logo.png';
import Carregando from './../../fragments/carregando';
import Valid from './validaLogin';
import api, { apiSMS } from './../../utilites/api';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputMask from 'react-input-mask';
import { withRouter } from 'react-router-dom';
import { InputAdornment } from '@material-ui/core';
import { Phone, User } from 'lucide-react';
import { FormControl } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.min.css';

// import { Container } from './styles';

export default class Login extends Component {

  state = {
    telefone: '',
    isLogin: true,
    isLoading: false,
    mdCadastro: false,
    nomeCadastro: '',
    cpfCadastro: '',
    open: false,
    emailCadastro: '',
    showModal: false,
    showLogin: false,
    showCadastro: false,
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'telefone') {
      const unmaskedValue = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
      this.setState({ [name]: unmaskedValue });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleChange2 = e => {
    var ste = e.target.value.replace(/[^0-9]/g,'');
    this.setState({ [e.target.name]: ste });
  };

  async componentDidMount() {
    this.setState({ validador: Math.floor(Math.random() * (999999 - 100000 + 1) + 100000) + '' });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  ValidaTelefone = async () => {
    // Validação: telefone deve ter 11 dígitos e nome não pode estar vazio
    if (!this.state.telefone || this.state.telefone.length !== 11 || !this.state.nomeCadastro) {
      alert('Informe seu número de telefone e nome corretamente', 'Atenção', false);
      this.setState({ isLoading: false, isLogin: true });
      return;
    }
    // Exibe o menu de confirmação antes de prosseguir
    this.setState({ open: true });
  }

  VerificarCadastro = async () => {
    // if (this.state.codigo === this.state.validador) {
      this.setState({ isLoading: true, isLogin: false, isCodigo: false });
      const data = new FormData();
      data.append('numero', this.state.telefone);
      data.append('acao', 'consulta');
      const response = await api.post('ws/CadastrarUsuario.php', data);
      if (response.status === 200) {
        console.log('Resposta: ', response.data)
        if (response.data.Descricao === 'Usuario Nao Cadastrado') {
          this.setState({ isLoading: false, isLogin: true, mdCadastro: true });
        } else {

          localStorage.setItem('@webApp/username', response.data.Nome);
          localStorage.setItem('@webApp/userid', response.data.id);
          localStorage.setItem('@webApp/usertelefone', response.data.Telefone);
          localStorage.setItem('@webApp/usercpf', response.data.CPF);
          localStorage.setItem('@webApp/userdtnsc', response.data.Dt_Nsc);

          this.props.history.push({
            pathname: '/',
            state: {
              servico: response.data.Codigo,
            }
          })

        }
      } else {
        alert('Erro na comunicação com servidor!', 'Atenção', false);
        this.setState({ isLoading: false, isLogin: true });
      }
    // } else {
    //   alert('Código de validação incorreto', 'Atenção', false);
    // }
  }

  inicial() {
    // Responsivo para mobile e desktop
    // Usa clamp para tamanhos fluidos e breakpoints via CSS inline
    return (
      <div style={{
        minHeight: '100vh',
        background: '#fafbfc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 0.5rem',
      }}>
        <div
          style={{
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            padding: 'clamp(24px,7vw,48px) clamp(12px,5vw,32px)',
            minWidth: 0,
            maxWidth: 400,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxSizing: 'border-box',
          }}
        >
          <img
            src={logo}
            style={{
              width: 'clamp(64px,28vw,120px)',
              height: 'clamp(64px,28vw,120px)',
              marginBottom: 16,
              objectFit: 'contain',
              display: 'block',
            }}
            alt="Logo"
          />
          <div style={{ width: '100%', marginBottom: 8 }}>
            <span style={{ fontSize: 'clamp(20px,6vw,28px)', fontWeight: 700, color: '#222' }}>Login</span>
          </div>
          <div style={{ width: '100%', marginBottom: 24 }}>
            <span style={{ color: '#555', fontSize: 'clamp(13px,3.7vw,15px)' }}>
              Insira o número do seu telefone com DDD para realizar o login.<br />
              Caso seja seu primeiro acesso, você irá preencher um formulário de inscrição.
            </span>
          </div>
          <FormControl style={{ width: '100%', marginBottom: 24 }} variant="standard">
            <InputLabel htmlFor="input-with-icon-adornment">Telefone</InputLabel>
            <Input
              inputComponent={InputMask}
              inputProps={{
                mask: '(99) 99999-9999',
                maskChar: null,
                placeholder: '(99) 99999-9999',
                inputMode: 'tel',
                style: { letterSpacing: 1 }
              }}
              id="input-with-icon-adornment"
              startAdornment={
                <InputAdornment position="start">
                  <Phone style={{ color: "#9D2229" }} />
                </InputAdornment>
              }
              value={this.state.telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3').slice(0, 15)}
              onChange={this.handleChange}
              name="telefone"
              autoComplete="tel"
              style={{
                fontSize: 'clamp(15px,4.5vw,20px)',
                minHeight: 40,
                background: '#fafbfc',
                borderRadius: 8,
                paddingLeft: 8,
                maxWidth: '100%',
                boxSizing: 'border-box',
              }}
            />
          </FormControl>
          <FormControl style={{ width: '100%', marginBottom: 32 }} variant="standard">
            <label htmlFor="input-nome" style={{
              fontSize: 'clamp(13px,3.7vw,15px)',
              color: '#888',
              marginBottom: 4,
              marginLeft: 2,
              fontWeight: 500,
              display: 'block',
            }}>Nome</label>
            <Input
              id="input-nome"
              value={this.state.nomeCadastro}
              name="nomeCadastro"
              onChange={this.handleChange}
              autoComplete="name"
              startAdornment={
                <InputAdornment position="start">
                  <User style={{ color: "#9D2229" }} />
                </InputAdornment>
              }
              style={{
                fontSize: 'clamp(15px,4.5vw,20px)',
                minHeight: 40,
                background: '#fafbfc',
                borderRadius: 8,
                paddingLeft: 8,
                maxWidth: '100%',
                boxSizing: 'border-box',
              }}
            />
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            style={{
              width: '100%',
              fontWeight: 600,
              fontSize: 'clamp(16px,4.5vw,22px)',
              minHeight: 44,
              borderRadius: 8,
              boxShadow: '0 2px 8px rgba(157,34,41,0.08)',
              background: (this.state.telefone.length === 11 && this.state.nomeCadastro.length > 0) ? '#9D2229' : '#e0e0e0',
              color: (this.state.telefone.length === 11 && this.state.nomeCadastro.length > 0) ? '#fff' : '#888',
              transition: 'background 0.2s',
              marginBottom: 0,
            }}
            onClick={this.ValidaTelefone}
            disabled={
              this.state.telefone.length !== 11 ||
              !this.state.nomeCadastro
            }
          >
            CONTINUAR
          </Button>
        </div>
      </div>
    );
  }

  form() {
    if (this.state.isLoading) {
      return <Carregando />;
    } else {
      return (
        <>
          {this.inicial()}
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirmação de Dados"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {`Verifique se seu número e nome estão corretos:`}
                <br />
                {this.state.telefone || '(não informado)'}
                <br />
                {this.state.nomeCadastro || '(não informado)'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.handleConfirmLogin} color="primary" autoFocus>
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    }
  }

  handleConfirmLogin = async () => {
    this.setState({ open: false, isLoading: true });
    const data = new FormData();
    data.append('numero', this.state.telefone);
    data.append('acao', 'consulta');
    const response = await api.post('ws/CadastrarUsuario.php', data);
    if (response.status === 200) {
      if (response.data.Descricao === 'Usuario Nao Cadastrado') {
        // Usuário não existe, cadastra automaticamente
        const dataCadastro = new FormData();
        dataCadastro.append('nome', this.state.nomeCadastro);
        dataCadastro.append('telefone', this.state.telefone);
        dataCadastro.append('CPF', this.state.cpfCadastro);
        dataCadastro.append('Dt_Nsc', '');
        dataCadastro.append('acao', 'cadastrar');
        const respCadastro = await api.post('ws/CadastrarUsuario.php', dataCadastro);
        if (respCadastro.status === 200 && respCadastro.data && respCadastro.data.Descricao !== 'Usuario Nao Cadastrado') {
          localStorage.setItem('@webApp/username', respCadastro.data.Nome);
          localStorage.setItem('@webApp/userid', respCadastro.data.id);
          localStorage.setItem('@webApp/usertelefone', respCadastro.data.Telefone);
          localStorage.setItem('@webApp/usercpf', respCadastro.data.CPF);
          localStorage.setItem('@webApp/userdtnsc', respCadastro.data.Dt_Nsc);
          this.props.history.push({
            pathname: '/',
            state: {
              servico: respCadastro.data.Codigo,
            }
          });
        } else {
          alert('Erro ao cadastrar usuário!', 'Atenção', false);
          this.setState({ isLoading: false });
        }
      } else {
        // Usuário existe, logar
        localStorage.setItem('@webApp/username', response.data.Nome);
        localStorage.setItem('@webApp/userid', response.data.id);
        localStorage.setItem('@webApp/usertelefone', response.data.Telefone);
        localStorage.setItem('@webApp/usercpf', response.data.CPF);
        localStorage.setItem('@webApp/userdtnsc', response.data.Dt_Nsc);
        this.props.history.push({
          pathname: '/',
          state: {
            servico: response.data.Codigo,
          }
        });
      }
    } else {
      alert('Erro na comunicação com servidor!', 'Atenção', false);
      this.setState({ isLoading: false, isLogin: true });
    }
  }


  render() {
    return this.form();
  }

  // mdCadastro removido, cadastro é automático na tela de login
}
